<template>
  <div id="app" v-cloak>
    <navigation>
      <router-view />
    </navigation>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
* {
 -webkit-overflow-scrolling: touch;
}
html,body{margin:0;padding:0;}
[v-cloak] { 
  display: none; 
} 
#app {
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue